module.exports = __webpack_public_path__ + "img/pgd_a_00111.2ae56e69.png";